import React, { FC } from 'react'
import Button from '@bt-react/components/Button'
import { GigButtonProps } from './types'
import styles from './GigButton.module.scss'
import config from './GigButtonStates'

const GigButton: FC<GigButtonProps> = ({ status, onClickStart, onClickEnd }) => {

  const { colour, text, disabled, visible, state } = config(status)

  let handleClick

  switch (state) {

    case 'start':
      handleClick = onClickStart
      break
    case 'end':
      handleClick = onClickEnd
      break
    default:
      handleClick = () => {}

  }

  return visible
    ? <Button
      color={colour}
      text={text}
      onClick={handleClick}
      disabled={disabled}
      dataBdd='talks-publish-button'
      className={styles['talks-publish-button']}
    />
    : null

}

export default GigButton
